module.exports = __webpack_public_path__ + "static/img/guiluyaoye3.ba9a31ef.png";